import { useLocation } from "react-router-dom";
import $ from "jquery";
import { Link } from "react-router-dom";
// import { hasPermission } from "../../../utils/commonfunction";
import logo from "../../../../src/assets/logos/new_logo_white_1.png";
import { useTranslation } from "react-i18next";
import { isDevMode } from "../../../utils/commonfunction";

const SideBar = () => {
  const loc = useLocation();
  const { t } = useTranslation();

  const toggleDropdown = (e) => {
    e.preventDefault();
    const dropDown = e.target.closest(".nav-item");
    if (!dropDown) {
      return;
    }

    if (dropDown.classList.contains("show")) {
      dropDown.classList.remove("show");
    } else {
      dropDown.classList.add("show");
    }
  };

  const hoverSidebar = (e) => {
    if (window.matchMedia("(max-width: 1199px)").matches) {
      return;
    }

    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").addClass("main-sidebar-open");
    } else {
      $("body").removeClass("main-sidebar-open");
    }
  };

  const removeHoverSidebar = (e) => {
    if (window.matchMedia("(max-width: 1199px)").matches) {
      return;
    }

    $("body").removeClass("main-sidebar-open");
  };

  const closeSmallScreenSidebar = (e) => {
    const link = e.target.closest(".nav-link, .nav-sub-link");
    const isSubmenuToggle = link?.classList.contains("with-sub");

    if (
      window.matchMedia("(max-width: 1199px)").matches &&
      link &&
      !isSubmenuToggle
    ) {
      $("body").removeClass("main-sidebar-open");
    }
  };

  return (
    <div
      className="main-sidebar main-sidebar-sticky side-menu ps ps--active-y"
      id="app_sidebar"
      onMouseEnter={hoverSidebar}
      onMouseLeave={removeHoverSidebar}
      onClick={closeSmallScreenSidebar}
    >
      <div className="sidemenu-logo">
        <a className="main-logo" href="/admin/dashboard">
          <img
            src={logo}
            className="header-brand-img desktop-logo   rounded"
            style={{ height: "2.3rem"}}
            alt="logo"
            id="logo_full"
          />
        </a>
      </div>
      {/* Dashboard section start */}
      <div className="main-sidebar-body">
        <ul className="nav">
          <li className="nav-item">
            <Link
              className={
                "nav-link" +
                (loc.pathname === "/admin/dashboard" ? " sidebar-active" : "")
              }
              to="/admin/dashboard"
            >
              <i className="fa fa-home sidemenu-icon"></i>
              <span className="sidemenu-label">
                {t("sidebar_link_dashboard")}
              </span>
            </Link>
          </li>
          {/* Dashboard section end */}

          {/* restaurant management section end */}

          {/* {hasPermission("/admin/user-management") ? ( */}
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/restaurant-management")
                  ? "show"
                  : "")
              }
            >
              <Link
                className={
                  "nav-link" +
                  (loc.pathname.includes("/restaurant-management") ? " sidebar-active" : "")
                }
                to={`/admin/restaurant-management/restaurant/list/${1}`}
              >
                <i className="fa fa-utensils sidemenu-icon"></i>
                <span className="sidemenu-label">
                  {t("sidebar_link_restaurants")}
                </span>
              </Link>
            </li>
          {/* ) : null} */}
          {/* restaurant management section end */}

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/chatbot-management") ? "show" : "")
            }
          >
            <Link
              className={
                "nav-link" +
                (loc.pathname.includes("/chatbot-management") ? " sidebar-active" : "")
              }
              to="/admin/chatbot-management"
            >
              <i className="fa fa-robot sidemenu-icon"></i>
              <span className="sidemenu-label">{t("admin_chatbot_title")}</span>
            </Link>
          </li>

          {/* Cms section start */}
          {/* {hasPermission("/admin/cms") ? ( */}
            <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/cms") ? "show" : "")
              }
            >
              <a
                className={
                  "nav-link with-sub submenu" +
                  (loc.pathname.includes("/cms") ? " sidebar-active" : "")
                }
                onClick={toggleDropdown}
                href={"/"}
              >
                <i className="fa fa-edit sidemenu-icon"></i>
                <span className="sidemenu-label">{t("sidebar_link_cms")}</span>
                <i className="angle fe fe-chevron-right"></i>
              </a>
              <ul className="nav-sub">
                <li
                  className={`nav-sub-item ${loc.pathname.includes("/cms/pages") ? " active" : ""
                    }`}
                >
                  <Link
                    className="nav-sub-link"
                    to={`/admin/cms/pages/list/${1}`}
                  >
                    {t("sidebar_link_pages")}
                  </Link>
                </li>
                <li
                  className={`nav-sub-item ${loc.pathname.includes("/cms/banner") ? " active" : ""
                    }`}
                >
                  <Link
                    className="nav-sub-link"
                    to={`/admin/cms/banner/list/${1}`}
                  >
                    {t("sidebar_link_banners")}
                  </Link>
                </li>
                <li
                  className={
                    "nav-sub-item" +
                    (loc.pathname.includes("/cms/default-email-template")
                      ? " active"
                      : "")
                  }
                >
                  <Link
                    className="nav-sub-link"
                    to={`/admin/cms/default-email-template/list/${1}`}
                  >
                    {t("sidebar_link_email_template")}
                  </Link>
                </li>

                <li
                  className={
                    "nav-sub-item" +
                    (loc.pathname.includes("/cms/settings") ? " active" : "")
                  }
                >
                  <Link className="nav-sub-link" to={`/admin/cms/settings`}>
                    {t("sidebar_link_global_settings")}
                  </Link>
                </li>
              </ul>
            </li>
          {/* // ) : null} */}
          {/* Cms section end */}

          {/* testimonial management section end */}
           <li
              className={
                `nav-item ` +
                (loc.pathname.includes("/testimonial-management")
                  ? "show"
                  : "")
              }
            >
              <Link
                className={
                  "nav-link" +
                  (loc.pathname.includes("/testimonial-management") ? " sidebar-active" : "")
                }
                to={`/admin/testimonial-management/testimonial/list/${1}`}
              >
                <i className="fa fa-comment-dots sidemenu-icon"></i>
                <span className="sidemenu-label">
                {t("sidebar_link_testimonials")}
                </span>
              </Link>
            </li>
          {/* testimonial management section end */}


          {/*  Inquiries section end */}

          <li
            className={
              `nav-item ` +
              (loc.pathname.includes("/inquiries")
                ? "show"
                : "")
            }
          > 
            <Link
              className={
                "nav-link" +
                (loc.pathname.includes("/inquiries") ? " sidebar-active" : "")
              }
              to={`/admin/inquiries/list/${1}`}
            >
              {/* <i className="fa fa-comment-dots mr-2 ml-2 mb-0 h5"></i> */}
              <i className="fas fa-question-circle sidemenu-icon"></i>
              <span className="sidemenu-label">
              {t("sidebar_link_inquiries")}
              </span>
            </Link>
          </li>
          {
            isDevMode() ?
              <li
                className={
                  `nav-item ` +
                  (loc.pathname.includes("/manual-guide")
                    ? "show"
                    : "")
                }
              >
                <Link
                  className={
                    "nav-link" +
                    (loc.pathname.includes("/manual-guide") ? " sidebar-active" : "")
                  }
                  to={`/admin/manual-guide/list/${1}`}
                >
                  {/* <i className="fa fa-comment-dots mr-2 ml-2 mb-0 h5"></i> */}
                  <i className="fa fa-cogs sidemenu-icon"></i>
                  <span className="sidemenu-label">
                    Manual Guide
                  </span>
                </Link>
              </li>
              : null
          }
          
          {/* testimonial management section end */}


        </ul>
      </div>
    </div>
  );
};

export default SideBar;
